import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../config";
// import BackButton from ""; // Ya koi Admin Sidebar/Header

function AdminTickets() {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [updating, setUpdating] = useState(false);

    const token = localStorage.getItem("token");

    // Fetch All Tickets
    const fetchTickets = async () => {
        setLoading(true); // 🔥 Fix: Refresh dabane pe wapas loading start ho
        try {
            const res = await axios.get(`${API_URL}/api/tickets/all`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (res.data.success) {
                setTickets(res.data.data);
            }
        } catch (err) {
            console.error("Failed to fetch tickets", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
        // eslint-disable-next-line
    }, []);

    // Update Status Logic
    const handleUpdateStatus = async (ticketId, newStatus) => {
        setUpdating(true);
        try {
            const res = await axios.put(`${API_URL}/api/tickets/${ticketId}/status`,
                { status: newStatus },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res.data.success) {
                alert(`✅ Status updated to ${newStatus}`);
                fetchTickets(); // Refresh table
                setSelectedTicket(null); // Close modal
            }
        } catch (err) {
            alert("Failed to update status");
        } finally {
            setUpdating(false);
        }
    };

    // Status Badge Color Logic
    const getStatusBadge = (status) => {
        switch (status) {
            case 'Open': return <span className="badge bg-danger-subtle text-danger border border-danger">Open</span>;
            case 'In Progress': return <span className="badge bg-warning-subtle text-warning border border-warning">In Progress</span>;
            case 'Resolved': return <span className="badge bg-success-subtle text-success border border-success">Resolved</span>;
            case 'Closed': return <span className="badge bg-secondary-subtle text-secondary border border-secondary">Closed</span>;
            default: return <span className="badge bg-dark">{status}</span>;
        }
    };

    return (
        <div style={{ minHeight: "100vh", background: "#f4f6f9", paddingBottom: "50px", fontFamily: "'Poppins', sans-serif" }}>

            {/* Header */}
            <div className="bg-white shadow-sm p-4 mb-4 d-flex justify-content-between align-items-center" style={{ borderBottom: "4px solid #800000" }}>
                <div>
                    <h4 className="fw-bolder mb-0 text-dark">Helpdesk Dashboard</h4>
                    <p className="text-muted small mb-0">Manage User Support Tickets</p>
                </div>
                <button 
                    className="btn btn-light shadow-sm d-flex align-items-center gap-2 fw-bold text-muted" 
                    onClick={fetchTickets}
                    disabled={loading} // 🔥 Loading ke time disable ho jayega
                >
                    <i className={`bi bi-arrow-clockwise fs-5 text-primary ${loading ? 'spin-anim' : ''}`}></i> 
                    {loading ? 'Refreshing...' : 'Refresh'}
                </button>
            </div>

            <div className="container-fluid px-4">
                {/* Ticket Table Card */}
                <div className="card border-0 shadow-sm" style={{ borderRadius: "15px", overflow: "hidden" }}>
                    <div className="card-body p-0">
                        {loading ? (
                            // 🔥 SHIMMER LOADER FOR TABLE
                            <div className="table-responsive custom-scrollbar" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                                <table className="table align-middle mb-0">
                                    <thead style={{ background: "#f8f9fa", borderBottom: "2px solid #eee" }}>
                                        <tr>
                                            <th className="text-muted small fw-bold px-4 py-3">TICKET ID</th>
                                            <th className="text-muted small fw-bold py-3">USER</th>
                                            <th className="text-muted small fw-bold py-3">SUBJECT</th>
                                            <th className="text-muted small fw-bold py-3">DATE</th>
                                            <th className="text-muted small fw-bold py-3">STATUS</th>
                                            <th className="text-muted small fw-bold text-end px-4 py-3">ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {[1, 2, 3, 4, 5].map((i) => (
                                            <tr key={i} className="placeholder-glow border-bottom">
                                                <td className="px-4 py-3"><span className="placeholder col-8 bg-secondary opacity-10 rounded"></span></td>
                                                <td className="py-3">
                                                    <span className="placeholder col-10 bg-secondary opacity-10 rounded mb-1 d-block"></span>
                                                    <span className="placeholder col-6 bg-secondary opacity-10 rounded d-block"></span>
                                                </td>
                                                <td className="py-3"><span className="placeholder col-9 bg-secondary opacity-10 rounded"></span></td>
                                                <td className="py-3"><span className="placeholder col-6 bg-secondary opacity-10 rounded"></span></td>
                                                <td className="py-3"><span className="placeholder col-8 bg-secondary opacity-10 rounded" style={{ height: "25px", borderRadius: "20px" }}></span></td>
                                                <td className="text-end px-4 py-3"><span className="placeholder col-10 bg-secondary opacity-10 rounded" style={{ height: "30px", maxWidth: "100px" }}></span></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : tickets.length === 0 ? (
                            <div className="text-center p-5 text-muted fw-bold">No Support Tickets Found! 🎉</div>
                        ) : (
                            <div className="table-responsive custom-scrollbar" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                                <table className="table table-hover align-middle mb-0">
                                    {/* 🔥 FIX: Added Sticky Header (top: 0, zIndex: 10) so it doesn't move */}
                                    <thead style={{ position: "sticky", top: 0, zIndex: 10, background: "#f8f9fa", boxShadow: "0 2px 4px rgba(0,0,0,0.05)" }}>
                                        <tr>
                                            <th className="text-muted small fw-bold px-4 py-3 border-0">TICKET ID</th>
                                            <th className="text-muted small fw-bold py-3 border-0">USER</th>
                                            <th className="text-muted small fw-bold py-3 border-0">SUBJECT</th>
                                            <th className="text-muted small fw-bold py-3 border-0">DATE</th>
                                            <th className="text-muted small fw-bold py-3 border-0">STATUS</th>
                                            <th className="text-muted small fw-bold text-end px-4 py-3 border-0">ACTION</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {tickets.map((ticket) => (
                                            <tr key={ticket._id} style={{ cursor: "pointer", transition: "0.2s" }} className="hover-bg-light">
                                                <td className="px-4 py-3 fw-bold text-primary">{ticket.ticketId}</td>
                                                <td className="py-3">
                                                    <div className="fw-bold">{ticket.user?.name || 'Unknown'}</div>
                                                    <div className="small text-muted">{ticket.user?.email}</div>
                                                </td>
                                                <td className="py-3 text-dark fw-semibold">{ticket.subject}</td>
                                                <td className="py-3 text-muted small">{new Date(ticket.createdAt).toLocaleDateString('en-GB')}</td>
                                                <td className="py-3">{getStatusBadge(ticket.status)}</td>
                                                <td className="text-end px-4 py-3">
                                                    <button
                                                        className="btn btn-sm text-white shadow-sm"
                                                        style={{ background: "#800000" }}
                                                        onClick={() => setSelectedTicket(ticket)}
                                                    >
                                                        View & Action
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* === TICKET DETAIL MODAL === */}
            {selectedTicket && (
                <>
                    {/* 1. PEECHE KA KALA PARDA (Backdrop alag rakha hai) */}
                    <div className="modal-backdrop fade show" style={{ backdropFilter: "blur(5px)", backgroundColor: "rgba(0,0,0,0.6)" }}></div>

                    {/* 2. MAIN MODAL (Backdrop ke bahar hai) */}
                    <div className="modal fade show d-block" tabIndex="-1" style={{ zIndex: 1050 }}>
                        <div className="modal-dialog modal-lg modal-dialog-centered">
                            <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden animate-up bg-white">

                                {/* Modal Header */}
                                <div className="modal-header border-0 text-white p-4" style={{ background: "linear-gradient(135deg, #800000 0%, #4A0000 100%)" }}>
                                    <div>
                                        <h5 className="modal-title fw-bold mb-1">Ticket Details: {selectedTicket.ticketId}</h5>
                                        <span className="small opacity-75">Raised on {new Date(selectedTicket.createdAt).toLocaleString()}</span>
                                    </div>
                                    <button type="button" className="btn-close btn-close-white" onClick={() => setSelectedTicket(null)}></button>
                                </div>

                                {/* Modal Body */}
                                <div className="modal-body p-4 bg-light custom-scrollbar" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <p className="text-muted small fw-bold mb-1">USER INFO</p>
                                            <h6 className="fw-bold mb-0">{selectedTicket.user?.name}</h6>
                                            <p className="text-muted small">{selectedTicket.user?.email}</p>
                                        </div>
                                        <div className="col-md-6 text-md-end">
                                            <p className="text-muted small fw-bold mb-1">CURRENT STATUS</p>
                                            {getStatusBadge(selectedTicket.status)}
                                        </div>
                                    </div>

                                    <div className="card border-0 shadow-sm rounded-3 mb-4">
                                        <div className="card-body p-3 bg-white">
                                            <p className="text-muted small fw-bold border-bottom pb-2 mb-3">SUBJECT: <span className="text-dark">{selectedTicket.subject}</span></p>
                                            <p className="text-dark" style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
                                                {selectedTicket.description}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Attachment Section */}
                                    {selectedTicket.attachment && (
                                        <div className="mb-4">
                                            <p className="text-muted small fw-bold mb-2">ATTACHED SCREENSHOT</p>
                                            <div className="text-center bg-white p-2 rounded-3 shadow-sm border">
                                                <img
                                                    src={selectedTicket.attachment}
                                                    alt="Attachment"
                                                    className="img-fluid rounded"
                                                    style={{ maxHeight: "300px", objectFit: "contain" }}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* Action Section */}
                                    <div className="bg-white p-3 rounded-3 shadow-sm border mt-3">
                                        <p className="text-muted small fw-bold mb-2">UPDATE TICKET STATUS</p>
                                        <div className="d-flex gap-2">
                                            <button className="btn btn-outline-danger fw-bold flex-grow-1" disabled={updating} onClick={() => handleUpdateStatus(selectedTicket._id, 'Open')}>Mark Open</button>
                                            <button className="btn btn-outline-warning fw-bold flex-grow-1" disabled={updating} onClick={() => handleUpdateStatus(selectedTicket._id, 'In Progress')}>In Progress</button>
                                            <button className="btn btn-success fw-bold flex-grow-1" disabled={updating} onClick={() => handleUpdateStatus(selectedTicket._id, 'Resolved')}>Resolve</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* CSS */}
          
            <style>{`
                .hover-bg-light:hover { background-color: #ffffff; }
                
                /* Animations */
                .animate-up { animation: fadeInUp 0.3s ease-out both; }
                @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
                
                /* Refresh Spin Animation */
                .spin-anim { animation: spin 1s linear infinite; }
                @keyframes spin { 100% { transform: rotate(360deg); } }

                /* 🔥 NEW: Premium Custom Scrollbar */
                .custom-scrollbar::-webkit-scrollbar {
                    width: 6px;
                    height: 6px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: #f1f1f1; 
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #c0c0c0; 
                    border-radius: 10px;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #800000; /* Hover pe Maroon color */
                }
            `}</style>
        </div>
    );
}

export default AdminTickets;